// Configuration settings for HyperCore store

export const config = {
  // Backend API URL - Replace with your Render URL after deployment
  apiUrl: 'https://hypercore.onrender.com', // Change to https://your-app.onrender.com in production

  // Contact information
  contact: {
    discord: 'https://discord.com/invite/hypercore',
    facebook: 'https://discord.com/invite/hypercore', // Replace with your Facebook page
    email: 'support@hypercore.com' 
  },
  
  // Site settings
  siteName: 'HyperCore',
  defaultCurrency: 'USD'
};